// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@west/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import { categoryDetailSubCategoriesStyles } from "@west/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { color } from "@west/XDL/Utilities";
import { viewAllStyle } from "@west/XDL/Utilities/links";
import { css } from "styled-components";

categoriesStyles.container = {};

categoriesStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 24px;
    `,
};

categoriesStyles.categoryContainer = {
    gap: 22,
};

categoriesStyles.categoryItemRow = {
    width: [12, 6, 4, 3, 3],
};

categoriesStyles.innerCategoryContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;

        width: 100%;
        height: 100%;
        padding: 13px;
        border: 1px solid ${color("common.border")};
    `,
};

categoriesStyles.innerInformationContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
    `,
};

categoriesStyles.categoryImageItem = {
    css: css`
        width: 88px;
        height: 88px;
        flex-shrink: 0;
        flex-grow: 0;
    `,
};

categoriesStyles.categoryImageLink = {
    css: css`
        width: 100%;
        height: 100%;
    `,
};

categoriesStyles.categoryImage = {
    css: css`
        width: 100%;
        height: 100%;

        img {
            width: auto;
            height: auto;
            max-height: 100%;
            max-width: 100%;
        }
    `,
};

categoriesStyles.categoryNameLinkItem = {};

categoriesStyles.categoryNameLink = {
    color: "text.main",
    typographyProps: {
        variant: "h5",
        size: 16,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 22px;
            margin-bottom: 0;
        `,
    },
};

categoriesStyles.subCategoryItem = {
    css: css`
        width: 100%;
        align-self: flex-start;
        line-height: 18px;
    `,
};

categoriesStyles.subCategoryLink = {
    color: "text.main",
    typographyProps: {
        weight: "normal",
        lineHeight: "18px",
    },
};

categoriesStyles.viewMoreLinkItem = {
    css: css`
        margin-top: auto;
        padding-top: 4px;
    `,
};

categoriesStyles.viewMoreLink = {
    ...viewAllStyle,
};
